import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { AuthService } from '@/pages/service/auth.service';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu {
    model: MenuItem[] = [];

    constructor(private readonly authService: AuthService) {}

    ngOnInit() {
        const user = JSON.parse(this.authService.user || '{}');
        const mainRole = user.roles?.[0]?.toLowerCase() || '';
        const sinSede = user.sede_id === null || user.sede_id === undefined;
        const esSuperAdmin = mainRole === 'superadministrador';

        if (esSuperAdmin) {
            this.model = [
                {
                    label: 'INICIO',
                    items: [{ label: 'Panel de control', icon: 'pi pi-fw pi-home', routerLink: ['/virtual'] }]
                },
                {
                    label: 'VIRTUAL',
                    items: [
                        { label: 'Entidades',      icon: 'pi pi-fw pi-building',     routerLink: ['/virtual/entidades']      },
                        { label: 'Usuarios',       icon: 'pi pi-fw pi-users',        routerLink: ['/virtual/usuarios']       },
                        { label: 'Planes',         icon: 'pi pi-fw pi-credit-card',  routerLink: ['/virtual/planes']         },
                        { label: 'Suscripciones',  icon: 'pi pi-fw pi-receipt',      routerLink: ['/virtual/suscripciones']  }
                    ]
                }
            ];
            return;
        }

        const adminItems: MenuItem[] = [
            { label: 'Usuarios', icon: 'pi pi-fw pi-id-card', routerLink: ['/administracion/usuarios'] }
        ];

        if (sinSede) {
            adminItems.push(
                { label: 'Invitaciones', icon: 'pi pi-fw pi-envelope', routerLink: ['/administracion/invitaciones'] },
                { label: 'Sedes', icon: 'pi pi-fw pi-building', routerLink: ['/administracion/sedes'] }
            );
        }

        adminItems.push({ label: 'Mi Plan', icon: 'pi pi-fw pi-credit-card', routerLink: ['/mi-plan'] });

        this.model = [
            {
                label: 'INICIO',
                items: [{ label: 'Panel de control', icon: 'pi pi-fw pi-home', routerLink: ['/dashboard'] }]
            },
            {
                label: 'ADMINISTRACIÓN',
                items: adminItems
            },
            {
                label: 'REPORTES',
                items: [
                    { label: 'Reporte',    icon: 'pi pi-fw pi-chart-bar',   routerLink: ['/reportes']   },
                    { label: 'Novedades',  icon: 'pi pi-fw pi-file-edit',   routerLink: ['/novedades']  }
                ]
            },
        ];
    }
}
